<template>
    <div v-if="isLoaded">
        <TrackingItem
            v-for="(orderItem) in orderTrackingList"
                :key="orderItem.id"
                :orderItem="orderItem"
        ></TrackingItem>
        <div class="flex lg:hidden" v-if="orderTrackingList.length > 0">
            <div class="w-52 m-auto pb-4">
                <Contact @onClick="onClickContactCC()"></Contact>
            </div>
        </div>
    </div>
</template>

<script>

//component
import TrackingItem from './TrackingItem.vue';
import Contact from './Contact.vue';
//service
import BKMyOrder from '../../service/BKMyOrder.js'
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";


export default {
    name: 'OnGoing',
    mixins: [LocaleMixin,ModalMixin],
    components: {
        TrackingItem,
        Contact
    },
    data: function () {
        return {
            isLoaded: false,
            orderTrackingList: [],
            freeList: [],
        };
    },
    created: function() {
        this.getTracking();
        this.init();
    },

    methods: {


        init : async function(){
            if (this.$route.query.from == "shoppingcart" ) {
                this.modal.errorModal.clearModal()
                                    .setMsg(this.lbl.myOrder.please_wait)
                                    .show();
                this.modal.errorModal.onClose(async ()=> {
                    this.FreeGiftModal()      
                 })
            } else{
                this.modal.loadingModal.show();
                if (await this.getTracking()) {
                    this.modal.loadingModal.hide();
                }
            }
        },
        FreeGiftModal: async function(){
            await this.apiFreeGift(this.$route.query.tranid);
            if(this.freeList.length > 0){
                this.modal.freeGiftModal.clearModal()
                                        .data(this.freeList[0])
                                        .show();
                this.modal.freeGiftModal.onClickOk(() => {
                    this.$router.push("/home");
                });
            } else {
                this.modal.loadingModal.show();
                this.isLoaded = false;
                if (await this.getTracking()) {
                    this.modal.loadingModal.hide();
                }
            }
        },
        apiFreeGift: function (tranId){
            return new Promise((resolve) => {
                BKMyOrder.apiGetFree(tranId).subscribe({
                    next: (data) => {          
                        this.freeList = data.data;
                        this.$emit('onLoaded');
                        resolve(true);                    
                    },
                    error: (err) => {
                        this.errorApi(err);
                        this.$emit('onLoaded');
                        resolve(false);
                    }
                })
            });
        },
        trackingService:function(){
            let orderList = this.orderTrackingList;

            // Add trackingOrderLabel
            if (orderList.length > 0) {
                orderList.forEach(order => {
                        this.tracking.event('shopping_bag','view_my_order',`order_success|${order.tranId}`);
                });
            }
        },
        getTracking: function() {
            return new Promise((resolve) => {
                BKMyOrder.apiGetOrderTracking().subscribe({
                    next: (data) => {
                        console.log(data);
                        this.orderTrackingList = data;
                        //this.orderDetail = this.orderItem.item;

                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = true;
                        this.$emit('onLoaded');
                        this.trackingService();
                        resolve(true);
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.errorApi(err);

                        this.$emit('onLoaded');
                        resolve(false);
                    }
                });
            });
        },
        onClickContactCC: function(){
            this.tracking.event('shopping_bag','Click_contact1112','call1112','When user click confirm to calling 1112​');
            window.open("tel:1122", "_self")
        }
    }
}
</script>

<style>

</style>
